import { backendApi } from "../dynamicBAseQuery";

export const ViewCandidatePaymentsApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getClientReferralCommissionDetails:builder.mutation ({
            query : (args) =>({
                method : "POST",
                url : "getClientReferralCommissionDetails",
                body : {...args}
            })
        }),
        referralCommissionApproval:builder.mutation({
            query:(args)=>({
                method:"POST",
                url:"referralCommissionApproval",
                params:args
            })
        }),

    })
})

export const {
    useReferralCommissionApprovalMutation,
   useGetClientReferralCommissionDetailsMutation,
} = ViewCandidatePaymentsApi